import { message } from "antd";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { filterByCondition } from "../filterByCondition";

export const useDateRange = ({ duplicaterooms, ratePlans, setRooms }) => {
  // Initialize fromdate as today and todate as next day
  const initialFromDate = moment().startOf("day");
  const initialToDate = moment().add(1, "days").startOf("day");
  const [adultsFilter, setAdultsFilter] = useState("");
  const [childrenFilter, setChildrenFilter] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const [dateRange, setDateRange] = useState([initialFromDate, initialToDate]);
  const [fromdate, setFromdate] = useState(
    initialFromDate.format("DD-MM-YYYY")
  );
  const [todate, setTodate] = useState(initialToDate.format("DD-MM-YYYY"));
  const [promoDiscount, setPromoDiscount] = useState(null);

  useEffect(() => {
    // Always apply initial filter on mount
    filterByCondition({
      dates: [initialFromDate, initialToDate],
      duplicaterooms,
      ratePlans,
      setFromdate,
      setTodate,
      setRooms,
      adultsFilter,
      childrenFilter,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duplicaterooms]);

  const handleApplyPromoAndFilter = async () => {
    if (!fromdate || !todate) {
      Swal.fire({
        title: "Error",
        text: `Check in and check out time is required`,
        icon: "error",
      });
      return;
    }
    if (fromdate === todate) {
      Swal.fire({
        title: "Error",
        text: "Check-in and check-out dates cannot be the same.",
        icon: "error",
      });
      return;
    }
    if (promoCode) {
      try {
        const response = await axios.post("/api/promotions/validate-promo", {
          promoCode,
        });
        const promotion = response.data;
        const today = moment();
        const stayStart = moment(promotion.applicableStayDates.startDate);
        const stayEnd = moment(promotion.applicableStayDates.endDate);
        const bookStart = moment(promotion.applicableBookDates.startDate);
        const bookEnd = moment(promotion.applicableBookDates.endDate);
        const isStayDateApplicable = moment(fromdate, "DD-MM-YYYY").isBetween(
          stayStart,
          stayEnd,
          null,
          "[]"
        );
        const isBookingDateApplicable = today.isBetween(
          bookStart,
          bookEnd,
          null,
          "[]"
        );

        if (isStayDateApplicable && isBookingDateApplicable) {
          setPromoDiscount({
            discountPercentage: promotion.discountPercentage,
            applicableRatePlans: promotion.applicableRatePlans,
            applicableRooms: promotion.applicableRooms,
          });
          message.success(
            `Promo code applied successfully! ${promotion.discountPercentage}% discount.`
          );
          // Re-filter rooms with promo code applied
          filterByCondition({
            dates: [
              moment(fromdate, "DD-MM-YYYY"),
              moment(todate, "DD-MM-YYYY"),
            ],
            duplicaterooms,
            ratePlans,
            setFromdate,
            setTodate,
            setRooms,
            adultsFilter,
            childrenFilter,
          });
        } else {
          setPromoDiscount(null);
          message.error("Promo code is not valid for the selected dates.");
        }
      } catch (error) {
        setPromoDiscount(null);
        message.error("Invalid promo code.");
      }
    } else {
      filterByCondition({
        dates: [moment(fromdate, "DD-MM-YYYY"), moment(todate, "DD-MM-YYYY")],
        duplicaterooms,
        ratePlans,
        setFromdate,
        setTodate,
        setRooms,
        adultsFilter,
        childrenFilter,
      });
      setPromoDiscount(null);
    }
  };

  const handleDateRangeChange = (newRange) => {
    const formattedFromDate = newRange[0]
      ? newRange[0].format("DD-MM-YYYY")
      : null;
    const formattedToDate = newRange[1]
      ? newRange[1].format("DD-MM-YYYY")
      : null;
    filterByCondition({
      dates: newRange,
      duplicaterooms,
      ratePlans,
      setFromdate,
      setTodate,
      setRooms,
      adultsFilter,
      childrenFilter,
    });

    setFromdate(formattedFromDate);
    setTodate(formattedToDate);
    setDateRange(newRange);
  };

  return {
    promoDiscount,
    fromdate,
    todate,
    adultsFilter,
    childrenFilter,
    promoCode,
    setAdultsFilter,
    setChildrenFilter,
    setPromoCode,
    dateRange,
    handleDateRangeChange,
    handleApplyPromoAndFilter,
  };
};
